import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { Product } from '../types';
import { productApi } from '../services/api';

const HomePage: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFeatured();
  }, []);

  const fetchFeatured = async () => {
    try {
      setLoading(true);
      const response = await productApi.getAll();
      
      setProducts(response.data.slice(0, 3));
    } catch (error) {
      console.error('Error fetching featured products:', error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #1269cc 0%, #6d9ac7 100%)',
        borderRadius: '12px',
        padding: '4rem 2rem',
        marginBottom: '3rem',
        textAlign: 'center',
        color: '#ffffff'
      }}>
        <h2 style={{ fontSize: '2.5rem', marginBottom: '1rem', fontWeight: 'bold' }}>
          Welcome to LetShop
        </h2>
        <p style={{ fontSize: '1.25rem', marginBottom: '2rem', opacity: 0.95 }}>
          Discover amazing products at unbeatable prices
        </p>
        <Link 
          to="/products"
          style={{
            backgroundColor: '#51eefc',
            color: '#303030',
            border: 'none',
            padding: '1rem 2.5rem',
            fontSize: '1.1rem',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'transform 0.2s',
            textDecoration: 'none',
            display: 'inline-block'
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          Shop Now
        </Link>
      </section>

      {/* Featured Products */}
      <section>
        <h3 style={{ fontSize: '2rem', marginBottom: '2rem', color: '#303030', fontWeight: 'bold' }}>
          Featured Products
        </h3>
        <div style={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: '2rem',
          justifyContent: 'center'
        }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '1rem', color: '#6d9ac7' }}>Loading...</div>
          ) : (
            products.map((product) => (
              <ProductCard key={product._id} product={product} />
            ))
          )}
        </div>
      </section>
    </div>
  );
};

export default HomePage;